import Signal from 'libs/signals';

const stateOrganizationsSignal = Signal({
  accounts: [],
  selectedAccount: null,
});

export default stateOrganizationsSignal;
